import React, { Component } from 'react';
import {Badge,Button,Col,Card,CardBody,FormGroup,Input,InputGroup,InputGroupButton,PaginationItem,PaginationLink,
  Row,Table} from 'reactstrap';
import Pagination from '../../components/Pagination';

// Firebase
import { app } from '../../base';

const TableRow = (props) => {
  return (
    <tr>
      <td>{(props.data.email || '')}</td>
        <td>{(props.data.user_name || '')}</td>
        <td>{(props.data.real_name || '')}</td>
        <td>
          <Input type="select" onChange={(e) => props.changeArea(props.rowKey, e.target.value)} defaultValue={props.data.area}>
            <option value=''>Select</option>
            {props.ddArea}
          </Input>
        </td>
    </tr>
  );
}

class Assign extends Component {
  constructor() {
    super();
    this.state = {
      pageOfItems: [],
      rows: [],
      searchRows: []
    };

    this.changeArea = this.changeArea.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
  }

  componentWillMount() {
    app.database().ref('locations').once('value')
    .then((snapshot)=>{
      let area = [], dd_area = [];
      snapshot.forEach((child)=>{
        let location = child.val();
        let area_code = location.area_code;
        if (area.indexOf(area_code) == -1) {
          area.push(area_code);
        }
      });

      area.sort();
      area.forEach((item)=>{
        dd_area.push(<option key={item} value={item}>{item}</option>);
      });

      app.database().ref('users').orderByChild('user_type').equalTo(3).on('value', (snapshot) => {
        var users = snapshot.val();
        var rows = [];
        for (var key in users) {
          rows.push(<TableRow key={key} data={users[key]} ddArea={dd_area} rowKey={key} changeArea={this.changeArea} />);
        }
        this.setState({rows, searchRows: rows});
      });
    });
  }

  changeArea(key, area){
    if (area == '') return;
    app.database().ref('users/' + key).update({area});
  }

  filterData(searchText, element){
    return (element.props.data.user_name.toLowerCase().indexOf(searchText) != -1)
  }

  onChangePage(pageOfItems) {
    // update state with new page of items
    this.setState({ pageOfItems: pageOfItems });
  }

  onSearch(event) {
    event.preventDefault()

    const searchText = this.searchInput.value

    if (this.state.searchRows.length == 0) return;

    var rows = this.state.searchRows.filter(this.filterData.bind(this, searchText));
    this.setState({rows:rows});
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Col md="4">
                  <FormGroup>
                    <form onSubmit={(event) => { this.onSearch(event) }} ref={(form) => { this.entryForm = form }}>
                      <InputGroup>
                        <Input size="10" type="text" placeholder="Enter user name here" innerRef={(input) => { this.searchInput = input }}/>
                        <InputGroupButton>
                          <Button color="info">Search</Button>
                        </InputGroupButton>
                      </InputGroup>
                    </form>
                  </FormGroup>
                </Col>  
                <Table bordered striped responsive size="sm">
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>User Name</th>
                      <th>Real Name</th>
                      <th>Area</th>
                    </tr>
                  </thead>
                  <tbody>{this.state.pageOfItems}</tbody>
                </Table>
                <nav>
                  <Pagination items={this.state.rows} onChangePage={this.onChangePage} />
                </nav>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default Assign;


// WEBPACK FOOTER //
// ./src/views/locations/Assign.js